import { Injectable } from '@angular/core';
import { AddressDetails } from './AddressDetails';

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoPsmaFarmService {

  constructor() { }

  preText = '';
  apiKey;
  apiKeyReverse;
  waitTime = 5000;
  autocompleteUrl = 'https://api.psma.com.au/predictive/address?query=';
  addressUrl = 'https://api.psma.com.au/predictive/address/';
  geocodeUrl = 'https://www.geocode.farm/v3/json/reverse/';
  initObj;
  autocompleteBox;
  country; language; psmaPoints; psmaSourceVector; isFeatureRemoving; autocompleteStreet;

  reverse( coor, cb, cbErr, cbTimeout) {
    if ( this.apiKeyReverse == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma-farm address reverse: apiKeyReverse is null');
      }
      return;
    }

    let link = this.geocodeUrl + '?lat=' + coor[1] + '&lon=' + coor[0] + '&key=' + this.apiKeyReverse + '&count=1';
    link = this.getLinkOptions(link);
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe(data => {
          if (data && data.geocoding_results.STATUS.status === 'SUCCESS') {
            const suggestions = data.geocoding_results.RESULTS[0];
            const address = suggestions.ADDRESS;
            const streetData: any = new AddressDetails();
            streetData.properties.streetNo = address.street_number;
            streetData.properties.street = address.street_name;
            streetData.properties.suburb = address.locality;
            streetData.properties.postcode = address.postal_code;
            streetData.properties.country = address.country;
            streetData.properties.state = address.admin_1;
            streetData.geometry.coordinates[0] = coor[0]; // lon
            streetData.geometry.coordinates[1] = coor[1]; // lat
            if (cb && typeof cb === 'function') {
              cb(streetData, { lat: parseFloat(suggestions.COORDINATES.latitude), lng: parseFloat(suggestions.COORDINATES.longitude) });
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('PsmaFarm reverse Error');
            }
          }

        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('PsmaFarm reverse Error');
            }
          }
        });
  }

  lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {
    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params is invalid, [0] : autocompleteBox');
      }
      return;
    }

    if (this.autocompleteBox == null) {
      this.autocompleteBox = params[0];
    }

    if (params.length > 1) {
      this.search(params[1], cb, cbErr, cbTimeout);
    }
  }

  search(sPartialAddress, cb, cbErr, cbTimeout) {
    if ( this.apiKey == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma-farm address lookup: apiKey is null');
      }
      return;
    }
    if ( sPartialAddress == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma-farm address lookup: text is null');
      }
      return;
    }
    
    const newText = sPartialAddress.trim();
    if (newText === this.preText) {
      if (cb && typeof cb === 'function') {
        cb(null);
      }
      return;
    }

    this.preText = newText;

    if ( newText.length < 3 ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma-farm address lookup: text is less than 3 characters');
      }
      return;
    }

    const link = this.autocompleteUrl + sPartialAddress;
    this.initObj.httpService.getAPI(link
      , { timeout: this.waitTime }, {Authorization: this.apiKey})
      .subscribe( dataResult => {

          if (dataResult && dataResult.suggest) {

            const suggestions = dataResult.suggest;
            const results = [];
            for (let i = 0; i < suggestions.length; i++) {
              const predict = suggestions[i];
              const sugg: any = {};
              sugg.street = predict.address; // show in UI
              sugg.id = predict.id;
              results.push(sugg);
            }

            if (cb && typeof cb === 'function') {
              cb(results);
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('PsmaFarm lookup Error ');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('PsmaFarm lookup Error ');
            }
          }
        });
  }

  selectionOption(tpl, model, cb) {
    const link = this.addressUrl + tpl.id;
    this.initObj.httpService.getAPI(link
      , { timeout: this.waitTime }, {Authorization: this.apiKey})
      .subscribe( dataResult => {
        if (dataResult != null && dataResult.address) {

          const obj: any = new AddressDetails();
          const properties = dataResult.address.properties;
          // SITE NAME
          if (properties.site_name) {
            obj.properties.locationDescription = properties.site_name;
          }
          // UNIT IDENTIFIER
          if (properties.complex_unit_identifier) {
            obj.properties.unitNo = properties.complex_unit_identifier;
            if (obj.properties.locationDescription) {
              obj.properties.locationDescription += '\n';
            }
            obj.properties.locationDescription += ((properties.complex_unit_type_description ?
              properties.complex_unit_type_description : (properties.complex_unit_type ?
                properties.complex_unit_type : '' )) + ' ' +
              properties.complex_unit_identifier ).trim();
          }
          // LEVEL
          if (properties.complex_level_number) {
            if (obj.properties.locationDescription) {
              obj.properties.locationDescription += '\n';
            }
            obj.properties.locationDescription += ((properties.complex_level_type_description ?
              properties.complex_level_type_description : (properties.complex_level_type ?
                properties.complex_level_type : '')) + ' ' +
              properties.complex_level_number ).trim();
          }
          obj.properties.locationDescription.trim();
          obj.properties.streetNo = properties.street_number_1;
          // DUAL NUMBERS
          if (typeof properties.street_number_2 !== 'undefined' &&
            properties.street_number_2 !== null &&
            properties.street_number_2 !== 'null' &&
            properties.street_number_2 !== '') {
            obj.properties.streetNo = obj.properties.streetNo + '-' +
              properties.street_number_2;
          }
          let streetType = '';
          if (typeof properties.street_type_description !== 'undefined' &&
            properties.street_type_description !== null &&
            properties.street_type_description !== 'null' &&
            properties.street_type_description !== '') {
            streetType = properties.street_type_description;
          } else if (typeof properties.street_type !== 'undefined' &&
            properties.street_type !== null &&
            properties.street_type !== 'null' &&
            properties.street_type !== '') {
            streetType = properties.street_type;
          }
          obj.properties.street = (properties.street_name + ' ' + streetType).trim();
          // SUFFIX
          if (typeof properties.street_suffix !== 'undefined' &&
            properties.street_suffix !== null &&
            properties.street_suffix !== 'null' &&
            properties.street_suffix !== '') {
            obj.properties.street = obj.properties.street + ' ' +
              properties.street_suffix;
          }
          obj.properties.suburb = properties.locality_name;
          obj.properties.postcode = properties.postcode;
          obj.properties.state = properties.state_territory;

          const lat = dataResult.address.geometry.coordinates[1];
          const lon = dataResult.address.geometry.coordinates[0];
          obj.geometry.coordinates[0] = lon;
          obj.geometry.coordinates[1] = lat;

          if (cb && typeof cb === 'function') {
            cb(obj);
          }
        }

      });
  }

  getLinkOptions( link) {
    if (this.country) { link += '&country=' + this.country; }
    if (this.language) { link += '&lang=' + this.language; }

    return link;
  }
  removeFeatures(isRemove) {
    if (this.psmaPoints == null) {
      this.psmaPoints = [];
      return;
    }

    const obj = this.initObj.mapFunc.mapObj.psmaRemovePoint(this.psmaPoints, this.psmaSourceVector);
    this.psmaPoints = obj.psmaPoints;
    this.psmaSourceVector = obj.psmaSourceVector;

    this.psmaPoints = [];
    this.isFeatureRemoving = isRemove;

  }
  removeStreet(cb) {
    if (this.autocompleteStreet == null) {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
    }
    if (this.autocompleteStreet == null) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    this.autocompleteStreet.value = '';
    if (this.psmaPoints && this.psmaPoints.length > 0) {
      if (!this.psmaSourceVector) {
        const obj = this.initObj.mapFunc.mapObj.psmaCreateLayer(this.psmaPoints);
        this.psmaSourceVector = obj.psmaSourceVector;
      }
      this.psmaSourceVector.clear();
    }

    this.removeFeatures(true);


    if (cb && typeof cb === 'function') {
      cb();
    }
  }
}
